module.exports = __webpack_public_path__ + "static/media/mealIcon.4a7c8820.svg";